import {noop} from '@sail/utils';
import {createContext} from 'react';

type KillSwitchContextType = readonly [
  killedIds: Set<string>,
  killComponents: (ids: string[]) => void,
];

const DEFAULT_KILLED_IDS: KillSwitchContextType = [new Set(), noop];

export default createContext<KillSwitchContextType>(DEFAULT_KILLED_IDS);
